import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Loader from "../components/Loader/Loader";

export default function UnauthenticatedRoute({ children }: { children: React.ReactNode }) {
  const { loadingAuth, isAuthenticated } = useAuth();

  if (loadingAuth) {
    return <Loader />;
  }

  if (isAuthenticated) {
    return <Navigate to="/feed" replace />;
  }

  return <>{children}</>;
}
